// extracted by mini-css-extract-plugin
export var card = "_4g-0";
export var content = "_4g-1";
export var contentLoading = "_4g-2";